'use strict';var _defineProperty=require('@babel/runtime/helpers/defineProperty'),Joi=require('joi');function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var _defineProperty__default=/*#__PURE__*/_interopDefaultLegacy(_defineProperty);var Joi__default=/*#__PURE__*/_interopDefaultLegacy(Joi);function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default['default'](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var schema = Joi__default['default'].object({
  timestamp: Joi__default['default'].number()["default"](Date.now()),
  message: Joi__default['default'].string().optional(),
  // code: Joi.number().greater(100).less(599).default(200),
  code: [Joi__default['default'].string().optional(), Joi__default['default'].number().optional()],
  data: Joi__default['default'].string(),
  extra: Joi__default['default'].object({
    userIp: Joi__default['default'].string().optional(),
    // userIp: Joi.string().ip().when('user.email', {
    //   is: Joi.not('undefined_token', 'anonymous_token', 'application_token').exist(),
    //   then: Joi.when('env', {
    //     is: Joi.not('development', 'dev'),
    //     then: Joi.required(),
    //     otherwise: Joi.optional(),
    //   }),
    //   otherwise: Joi.optional(),
    // }),
    requestId: Joi__default['default'].string(),
    env: Joi__default['default'].string(),
    application: Joi__default['default'].string(),
    apiType: Joi__default['default'].string().valid('graphql', 'rest'),
    url: Joi__default['default'].string().when('...code', {
      is: Joi__default['default'].number().greater(300).less(399).exist(),
      then: Joi__default['default'].required(),
      otherwise: Joi__default['default'].optional()
    }),
    redirectUrl: Joi__default['default'].string().when('...code', {
      is: Joi__default['default'].number().greater(300).less(399).exist(),
      then: Joi__default['default'].required(),
      otherwise: Joi__default['default'].optional()
    }).optional(),
    user: Joi__default['default'].object({
      jwt: Joi__default['default'].string().strip(true),
      token: Joi__default['default'].string().strip(true),
      refreshToken: Joi__default['default'].string().strip(true),
      refreshExpiration: Joi__default['default'].number().strip(true),
      id: Joi__default['default'].number().optional(),
      email: Joi__default['default'].string().when('.', {
        is: Joi__default['default'].not('undefined_token', 'anonymous_token', 'application_token').exist(),
        then: Joi__default['default'].string().email({
          tlds: {
            allow: false
          }
        })
      }),
      name: Joi__default['default'].string().optional(),
      // configs: Joi.object().optional(),
      keepConnected: Joi__default['default']["boolean"]().optional()
    }).optional(),
    error: Joi__default['default'].object({
      message: Joi__default['default'].string().optional(),
      stack: Joi__default['default'].string().optional() // message: Joi.string().required(),
      // stack: Joi.string().required(),

    }).optional(),
    payload: Joi__default['default'].object()
  }).optional() // }).required(),

});

var atob = function atob(b64Encoded) {
  return Buffer.from(b64Encoded, 'base64').toString('binary');
};

var decodeJWT = function decodeJWT(token) {
  if (token) {
    var base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
    }).join(''));
    var parser = JSON.parse(jsonPayload);
    return parser;
  }
};

var getUserInfoFromJWT = function getUserInfoFromJWT(token) {
  var decodedUserInfo = decodeJWT(token);
  var userInfo = {
    email: 'undefined_token'
  };

  if (token) {
    var _decodedUserInfo$data;

    if (decodedUserInfo !== null && decodedUserInfo !== void 0 && (_decodedUserInfo$data = decodedUserInfo.data) !== null && _decodedUserInfo$data !== void 0 && _decodedUserInfo$data.id) {
      userInfo.id = decodedUserInfo.data.id;
    }

    if (decodedUserInfo.aud === 'user' && decodedUserInfo.data.email === '') {
      userInfo.email = 'anonymous_token';
    } else if (decodedUserInfo.aud === 'application') {
      userInfo.email = 'application_token';
    } else {
      userInfo.email = decodedUserInfo.data.email;
    }
  }

  return userInfo;
}; // const getMessage = (payload) => {
//   let message = '';
//   if (payload?.extra?.requestId) {
//     message += `[${payload?.extra?.requestId}]`;
//   }
//   if (payload?.extra?.application) {
//     message += `[${payload?.extra?.application}] `;
//   }
//   message += payload?.message;
//   return message;
// };


var validateLogPayload = (function (payload, config) {
  var _payload$extra;

  if (!payload) {
    throw new Error('payload not provided');
  }

  var mergedPayload = _objectSpread(_objectSpread({}, payload), {}, {
    message: payload.message,
    extra: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.extra), {}, {
      user: _objectSpread({}, payload === null || payload === void 0 ? void 0 : (_payload$extra = payload.extra) === null || _payload$extra === void 0 ? void 0 : _payload$extra.user)
    })
  });

  if (!(config !== null && config !== void 0 && config.disableJWTDecode)) {
    var _payload$extra2, _payload$extra2$user, _payload$extra3, _payload$extra3$user, _mergedPayload$extra;

    var token = (payload === null || payload === void 0 ? void 0 : (_payload$extra2 = payload.extra) === null || _payload$extra2 === void 0 ? void 0 : (_payload$extra2$user = _payload$extra2.user) === null || _payload$extra2$user === void 0 ? void 0 : _payload$extra2$user.jwt) || (payload === null || payload === void 0 ? void 0 : (_payload$extra3 = payload.extra) === null || _payload$extra3 === void 0 ? void 0 : (_payload$extra3$user = _payload$extra3.user) === null || _payload$extra3$user === void 0 ? void 0 : _payload$extra3$user.token);
    var userInfo = getUserInfoFromJWT(token);
    mergedPayload.extra.user = _objectSpread(_objectSpread({}, mergedPayload === null || mergedPayload === void 0 ? void 0 : (_mergedPayload$extra = mergedPayload.extra) === null || _mergedPayload$extra === void 0 ? void 0 : _mergedPayload$extra.user), userInfo);
  }

  var _schema$validate = schema.validate(mergedPayload, {
    stripUnknown: false,
    abortEarly: false,
    allowUnknown: true
  }),
      error = _schema$validate.error,
      value = _schema$validate.value;

  if (error) {
    console.warn('[DatadogLogger] Payload validation error: ', error); // throw error;
  }

  return value;
});module.exports=validateLogPayload;